<div class="modal-header">
  <h4 class="modal-title">
    Nueva reservación
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body select-amenity">

  <p class="select-amenity-hint">
    Elige la amenidad que quieres reservar.
  </p>

  <div class="container-fluid">
    <div class="row">

      @if (loading) {
        @for (skeletonKey of skeletonKeys; track skeletonKey) {
          <div class="col-12 col-md-6 col-xl-4 mb-3">
            <p-skeleton height="72px" borderRadius="12px"></p-skeleton>
          </div>
        }
      } @else {
        @for (amenityOption of amenityOptions; track amenityOption.amenity.amenityId) {
          <div class="col-12 col-md-6 col-xl-4 mb-3">
            <button
              type="button"
              class="amenity-card d-flex align-items-center gap-3 w-100 min-w-0"
              [class.is-disabled]="!amenityOption.amenity.status"
              [disabled]="!amenityOption.amenity.status"
              (click)="select(amenityOption.amenity)">
              @if (amenityOption.amenity.image) {
                <span class="amenity-card-icon flex-shrink-0">
                  <img
                    [src]="amenityOption.amenity.image!.urlFile"
                    [alt]="'Icono de la amenidad ' + amenityOption.amenity.name" />
                </span>
              } @else {
                <span
                  class="amenity-card-icon is-fallback flex-shrink-0"
                  [ngStyle]="{ 'background-color': amenityOption.color.border }">
                  <i class="material-icons" aria-hidden="true">event</i>
                </span>
              }
              <span class="amenity-card-text d-flex flex-column min-w-0">
                <span class="amenity-card-name">
                  {{ amenityOption.amenity.name }}
                </span>
                @if (!amenityOption.amenity.status) {
                  <span class="amenity-card-badge">
                    No disponible
                  </span>
                }
              </span>
            </button>
          </div>
        } @empty {
          <div class="col-12">
            <p class="select-amenity-empty">
              Este fraccionamiento no tiene amenidades registradas.
            </p>
          </div>
        }
      }

    </div>
  </div>

</div>
